import * as React from "react";
import Prompt from "./prompt";

const App: React.FC = () => {

  return (
    <Prompt />
  )
};

export default App;
